import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  FIRST_WORKSHEET_COLUMN_WIDTHS,
  FIRST_WORKSHEET_HEADERS,
  SECOND_WORKSHEET_COLUMN_WIDTHS,
  SECOND_WORKSHEET_HEADERS
} from '../data/constants/orderAttachment6AExportHeaders';

const FIRST_WORKSHEET_NAME = 'słupy_do_likwidacji_ewidencja';
const SECOND_WORKSHEET_NAME = 'słupy_do_likwidacji_brak_w_ewid';
const LIGHT_RED_COLOR = 'ea9999';

export function generateExportFile(data) {
  const workbook = new ExcelJS.Workbook();
  createFirstWorksheet(data?.points_with_record, workbook);
  createSecondWorksheet(data?.points_without_record, workbook);

  workbook.xlsx
    .writeBuffer()
    .then((buffer) =>
      saveAs(
        new Blob([buffer]),
        `Eksport zał. 6a do rozliczenia - ${new Date().toLocaleDateString()}.xlsx`
      )
    )
    .catch((err) => console.log('generateExportFile(): Error writing excel export.', err));
}

function createFirstWorksheet(firstWorksheetData, workbook) {
  if (!Array.isArray(firstWorksheetData)) return;

  const firstWorksheet = workbook.addWorksheet(FIRST_WORKSHEET_NAME);

  firstWorksheet.addRow([
    '',
    'Dane NOSS/ KSP',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'dane opcjonalne',
    'Dane mapowane',
    '',
    'Informacja zwrotna wykonawcy FZ'
  ]);

  const headers = FIRST_WORKSHEET_HEADERS;
  const headersRow = [];

  for (let i = 0; i < headers.length; i++) {
    headersRow[i] = headers[i];
  }
  firstWorksheet.addRow(headersRow);

  for (let i = 0; i < firstWorksheetData.length; i++) {
    const pointData = firstWorksheetData[i];
    const rowValues = createRowWithKeys(pointData, FIRST_WORKSHEET_HEADERS);
    const addedRow = firstWorksheet.addRow(rowValues);

    addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (rowValues[colNumber - 1] === undefined) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: LIGHT_RED_COLOR }
        };
      }
    });
  }

  FIRST_WORKSHEET_COLUMN_WIDTHS.forEach((element, index) => {
    firstWorksheet.getColumn(index + 1).width = element;
  });

  firstWorksheet.autoFilter = {
    from: { row: 2, column: 1 },
    to: { row: 10000, column: headers.length }
  };
}

function createSecondWorksheet(secondWorksheetData, workbook) {
  if (!Array.isArray(secondWorksheetData)) return;

  const secondWorksheet = workbook.addWorksheet(SECOND_WORKSHEET_NAME);

  secondWorksheet.addRow([
    '',
    'dane wymagane',
    'dane opcjonalne',
    'dane wymagane',
    'dane opcjonalne',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'dane wymagane',
    '',
    '',
    '',
    '',
    'dane opcjonalne',
    '',
    'Dane mapowane',
    '',
    'Informacja zwrotna wykonawcy FZ'
  ]);

  const headers = SECOND_WORKSHEET_HEADERS;
  const headersRow = [];

  for (let i = 0; i < headers.length; i++) {
    headersRow[i] = headers[i];
  }
  secondWorksheet.addRow(headersRow);

  for (let i = 0; i < secondWorksheetData.length; i++) {
    const pointData = secondWorksheetData[i];
    const rowValues = createRowWithKeys(pointData, SECOND_WORKSHEET_HEADERS);
    const addedRow = secondWorksheet.addRow(rowValues);

    addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (rowValues[colNumber - 1] === undefined) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: LIGHT_RED_COLOR }
        };
      }
    });
  }

  SECOND_WORKSHEET_COLUMN_WIDTHS.forEach((element, index) => {
    secondWorksheet.getColumn(index + 1).width = element;
  });

  secondWorksheet.autoFilter = {
    from: { row: 2, column: 1 },
    to: { row: 10000, column: headers.length }
  };
}

function getValueOrUndefined(data, key) {
  return data && key in data ? data[key] : undefined;
}

function createRowWithKeys(data, keys) {
  const row = [];

  keys.forEach((key) => {
    row.push(getValueOrUndefined(data, key));
  });

  return row;
}
